// extracted by mini-css-extract-plugin
export default {"policyHightlighted":"meal_policy_policyHightlighted__ey4YE"};